import PropTypes from "prop-types";
import { ReactNode } from "react";

interface Props {
  featureCardDescription: string;
  featureCardTitle: string;
  icon?: ReactNode;
}

export const FeatureDevice = ({
  featureCardDescription = "Some description text of this feature goes here to try fill the space.",
  featureCardTitle = "Feature/Device",
  icon,
}: Props): JSX.Element => {
  return (
    <div className="w-[222px] flex flex-col items-center gap-3.5 justify-center relative transition-transform duration-250 lg:hover:scale-110 cursor-pointer">
      <div className="bg-[#b7f5f3] w-[100px] h-[100px] relative flex items-center gap-2.5 p-[19px] rounded-[500px] justify-center">
        <div className="flex w-[41px] items-center justify-around gap-2.5 px-2.5 py-0 relative">
          {icon}
        </div>
      </div>

      <div className="relative w-[226px] h-[195.98px] mr-[-4.00px]">
        <p className="left-0 text-[#657d84] text-center absolute font-about-carddescription w-[222px] tracking-[var(--about-carddescription-letter-spacing)] [font-style:var(--about-carddescription-font-style)] text-[length:var(--about-carddescription-font-size)] top-[100px] h-24 font-[number:var(--about-carddescription-font-weight)] leading-[var(--about-carddescription-line-height)]">
          {featureCardDescription}
        </p>

        <div className="h-0.5 bg-[#d8dbdd] absolute w-[170px] left-[26px] top-[78px]" />

        <div className="left-0 top-0 text-[#657d84] text-center absolute font-about-cardtitle w-[222px] tracking-[var(--about-cardtitle-letter-spacing)] [font-style:var(--about-cardtitle-font-style)] text-[length:var(--about-cardtitle-font-size)] h-[70px] font-[number:var(--about-cardtitle-font-weight)] leading-[var(--about-cardtitle-line-height)]">
          {featureCardTitle}
        </div>
      </div>
    </div>
  );
};

FeatureDevice.propTypes = {
  featureCardDescription: PropTypes.string.isRequired,
  featureCardTitle: PropTypes.string.isRequired,
  icon: PropTypes.node,
}; 